import { SalesforceLightningContactActionCreator } from './salesforceLightning.contact.actionCreator';
import { SalesforceContact } from '../../../../salesforce-shared/salesforce-service.models';

export class SalesforceClassicContactActionCreator extends SalesforceLightningContactActionCreator {
  protected mapContactToContactLabel(contact: SalesforceContact): string {
    return `${contact.name || contact.id}`;
  }
}
